module.exports = "https://www.gc-qa.gnp.com.mx/e69f3ba782bd778ee8e779a8281f4f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk_reg_back_right.png
// module id = 8096
// module chunks = 0